// Meta Pixel utility — initializes Facebook Pixel and exposes a tracker helper
const PIXEL_ID = '928009436591933'

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return
  initialized = true

  const w = window as any
  const d = document

  // Standard Meta Pixel bootstrap
  if (!w.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = d.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = d.getElementsByTagName('script')[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      d.head.appendChild(t)
    }
  }

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackEvent(event: string, params?: Record<string, any>) {
  if (typeof window === 'undefined') return
  const w = window as any
  if (!w.fbq) return
  if (params) {
    w.fbq('track', event, params)
  } else {
    w.fbq('track', event)
  }
}
